var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMovie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43213 6.655C3.43518 6.2173 3.6103 5.79836 3.91965 5.4887C4.229 5.17903 4.64776 5.00349 5.08546 5H35.1121C36.0255 5 36.7655 5.74167 36.7655 6.655V33.345C36.7624 33.7827 36.5873 34.2016 36.2779 34.5113C35.9686 34.821 35.5498 34.9965 35.1121 35H5.08546C4.64682 34.9996 4.22629 34.825 3.91628 34.5147C3.60627 34.2043 3.43213 33.7836 3.43213 33.345V6.655ZM13.4321 8.33333V31.6667H26.7655V8.33333H13.4321ZM6.76546 8.33333V11.6667H10.0988V8.33333H6.76546ZM30.0988 8.33333V11.6667H33.4321V8.33333H30.0988ZM6.76546 15V18.3333H10.0988V15H6.76546ZM30.0988 15V18.3333H33.4321V15H30.0988ZM6.76546 21.6667V25H10.0988V21.6667H6.76546ZM30.0988 21.6667V25H33.4321V21.6667H30.0988ZM6.76546 28.3333V31.6667H10.0988V28.3333H6.76546ZM30.0988 28.3333V31.6667H33.4321V28.3333H30.0988Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMovie);
export default __webpack_public_path__ + "static/media/IconMovie.eb8c5632.svg";
export { ForwardRef as ReactComponent };